/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { useAmp } from 'next/amp';

const Loading = ({ mobile, desktop }) => {
  const { isMobile } = useDeviceScreen();
  const isAmp = useAmp();
  const width = (isAmp || isMobile) ? mobile.width : desktop.width;
  const height = (isAmp || isMobile) ? mobile.height : desktop.height;

  return !isMobile ? (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="1" y="25" rx="10" ry="10" width="15" height="15" />
      <rect x="25" y="25" rx="5" ry="5" width="590" height="13" />
      <rect x="1" y="45" rx="10" ry="10" width="15" height="15" />
      <rect x="25" y="45" rx="5" ry="5" width="590" height="13" />
      <rect x="1" y="65" rx="10" ry="10" width="15" height="15" />
      <rect x="25" y="65" rx="5" ry="5" width="590" height="13" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="1" y="25" rx="10" ry="10" width="15" height="15" />
      <rect x="25" y="25" rx="5" ry="5" width="590" height="13" />
      <rect x="1" y="45" rx="10" ry="10" width="15" height="15" />
      <rect x="25" y="45" rx="5" ry="5" width="590" height="13" />
      <rect x="1" y="65" rx="10" ry="10" width="15" height="15" />
      <rect x="25" y="65" rx="5" ry="5" width="590" height="13" />
    </ContentLoader>
  );
};

Loading.propTypes = {
  mobile: PropTypes.object,
  desktop: PropTypes.object,
};

export default Loading;
